import axios from 'axios'

import { CF as ENDPOINT } from '../common/endpoints'
import { success, error } from '../main/toast-notifications'
import { t } from '../main/i18n'

const cfTogglr = document.querySelector('.j-cf-togglr')
const cfPanel = document.querySelector('.j-cf-panel')
const cfBtn = document.querySelector('.j-cf-btn')
const cfField = document.querySelector('.j-cf-computed')
const nameLastTriggers = document.querySelectorAll('.j-cf-name, .j-cf-last')
const updateNames = () => {
	cfPanel.querySelector('input[name="nome"]').value = document.querySelector(
		'.j-cf-name',
	).validity.valid
		? document.querySelector('.j-cf-name').value
		: t('required-field-error')
	cfPanel.querySelector('input[name="cognome"]').value =
		document.querySelector('.j-cf-last').validity.valid
			? document.querySelector('.j-cf-last').value
			: t('required-field-error')
}

if(nameLastTriggers && cfBtn && cfPanel) {
	nameLastTriggers.forEach((el) => {
		el.addEventListener('change', updateNames)
		el.addEventListener('keyup', updateNames)
	})
	updateNames()

	cfBtn.addEventListener('click', async (e) => {
		e.preventDefault()

		let errorMsg = t('cf-validation')
		// we can't have a form within a form, so we can't use native form alidation
		const fields = [
			{
				field: 'input[name="nome"]',
				label: 'name-field',
			},
			{
				field: 'input[name="cognome"]',
				label: 'surname-field',
			},
			{
				field: 'select[name="sesso"]',
				label: 'sex-field',
			},
			{
				field: 'input[name="bday"]',
				label: 'bday-field',
			},
			{
				field: 'input[name="comune"]',
				label: 'bday-place-field',
			},
		]

		const errorFields = fields.filter((el) => {
			const field = cfPanel.querySelector(el.field)
			return !field || !field.validity.valid || !String(field.value).trim()
		})
		if (errorFields.length) {
			errorMsg += errorFields.map(({ label }) => t(label)).join(', ')
			console.log(errorFields, errorMsg)
			error(errorMsg)
			return
		}

		// all fields valid
		try {
			const bday = cfPanel.querySelector('input[name="bday"]').valueAsDate ?? new Date(cfPanel.querySelector('input[name="bday"]').value)
			if (Number.isNaN(bday.getTime())) {
				throw new Error('Invalid birth date')
			}
			const params = fields.filter(({field}) => !field.includes('bday')).reduce(
				(obj, el) => ({
					...obj,
					[cfPanel.querySelector(el.field).name]: cfPanel.querySelector(el.field).value,
				}),
				{},
			)
			params.m = bday.getMonth() + 1
			params.d = bday.getDate()
			params.y = bday.getFullYear()

			const res = await axios.get(ENDPOINT, {
				params,
			})
			const codiceFiscale = String(res.data).trim().toUpperCase()
			if (!/^[A-Z0-9]{16}$/.test(codiceFiscale)) {
				throw new Error('Invalid fiscal code returned by server')
			}
			cfField.value = codiceFiscale
			success(t('cf-success'))
			cfTogglr.click()
		} catch (err) {
			console.error(`${err.name}: ${err.message}`)
			error(t('cf-error'))
		}
	})
}
